export default __webpack_public_path__ + "static/media/settings.e4399d42.svg";